import * as React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import Seo from "../components/seo"
import BigNewsBox from "../components/BigNewsBox"
import SmallNewsBox from "../components/SmallNewsBox"
import OtherNews from "../components/OtherNews"
import InterestingArticle from "../components/InterestingArticle"
import HashTags from "../components/HashTags"
import EmptyWarning from "../components/EmptyWarning"
import styled from "styled-components"
import AmosovaLeftBanner from "../components/ads/AmosovaLeftBanner"
import AmosovaBigTopBanner from "../components/ads/AmosovaBigTopBanner"

const CategoryTemplate = ({ data }) => {
  const posts = data.allSanityPost.nodes
  const postsSmallNews = data.sanityCategory.dedicatedList.listDedicatedArticles
  const tinyListNews = data.tinylist.nodes
  return (
    <Layout>
      <Seo
        title={data.sanityCategory.title}
        description={data.sanityCategory.description}
      />
      {data.sanityAdBanner.positionsOtherPages.topBar && (
        <AmosovaBigTopBanner />
      )}
      <div className="max-w-screen-xl mx-auto">
        <div className="grid grid-cols-4 gap-5">
          <div className="col-span-4 md:col-span-4 lg:col-span-2 row-span-4">
            {posts.length === 0 && <EmptyWarning />}
            {posts.map(post => (
              <BigNewsBox
                key={post.id}
                themeColor={post.categories.color}
                title={post.title}
                category={post.categories.title}
                categoryLink={post.categories.slug.current}
                subcategory={post.subcategory}
                publishDay={post.publishedAt}
                link={post.slug.current}
                text={post._rawExcerpt}
                image={post._rawMainImage}
              />
            ))}
          </div>
          <div className="col-span-4 md:col-span-2 lg:col-span-1 row-span-4">
            {postsSmallNews.map((postSmallNews, index) => (
              <SmallNewsBox
                key={index}
                themeColor={postSmallNews.categories.color}
                title={postSmallNews.title}
                categoryLink={postSmallNews.categories.slug.current}
                category={postSmallNews.categories.title}
                subcategory={postSmallNews.subcategory}
                link={postSmallNews.slug.current}
                image={postSmallNews._rawMainImage}
              />
            ))}
          </div>
          <div className="col-span-4 md:col-span-2 lg:col-span-1 row-span-4">
            {data.sanityAdBanner.positionsOtherPages.leftBar && (
              <AmosovaLeftBanner />
            )}
            <div>
              <div className="relative" style={{ height: "60px" }}>
                <CategoryBar className="bg-fb-blue rounded-none md:rounded flex items-center pl-5 font-opensanscond category-bar inherit md:absolute">
                  Лента новостей
                </CategoryBar>
              </div>

              <div className="divide-y divide-gray-300 px-3 bg-fb-blue bg-opacity-5">
                {tinyListNews.length === 0 && <EmptyWarning />}
                {tinyListNews.map((tinyNews, index) => (
                  <OtherNews
                    key={index}
                    themeColor={tinyNews.categories.color}
                    title={tinyNews.title}
                    category={tinyNews.subcategory}
                    categoryLink={tinyNews.categories.slug.current}
                    link={tinyNews.slug.current}
                  />
                ))}
              </div>
            </div>
            <InterestingArticle />
            <HashTags />
          </div>
        </div>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query($pathSlug: String!) {
    allSanityPost(
      sort: { fields: publishedAt, order: DESC }
      limit: 3
      filter: { categories: { slug: { current: { eq: $pathSlug } } } }
    ) {
      nodes {
        id
        slug {
          current
        }
        title
        categories {
          title
          slug {
            current
          }
          color
          description
        }
        publishedAt(formatString: "DD-MM-YYYY")
        subcategory
        _rawExcerpt(resolveReferences: { maxDepth: 10 })
        _rawMainImage(resolveReferences: { maxDepth: 10 })
      }
    }
    sanityCategory(slug: { current: { eq: $pathSlug } }) {
      title
      dedicatedList {
        listDedicatedArticles {
          title
          subcategory
          categories {
            title
            slug {
              current
            }
            color
          }
          slug {
            current
          }
          _rawMainImage(resolveReferences: { maxDepth: 10 })
        }
      }
    }
    tinylist: allSanityPost(
      sort: { fields: publishedAt, order: DESC }
      filter: { categories: { slug: { current: { eq: $pathSlug } } } }
      skip: 3
      limit: 15
    ) {
      nodes {
        id
        slug {
          current
        }
        title
        categories {
          slug {
            current
          }
          color
        }
        subcategory
      }
    }
    sanityAdBanner(id: { eq: "-6025e2e7-5795-581f-97b5-7436c86dbe7b" }) {
      positionsOtherPages {
        topBar
        leftBar
      }
    }
  }
`
const CategoryBar = styled.div`
  bottom: 0px;
  right: 5px;
  width: 100%;
  height: 60px;
`
export default CategoryTemplate
